export const LANGUAGES_ARRAY = ["en", "es", "uk"];
